import { getStringsFromLocalStorage, syncStringsToLocalStorage } from "./local-storage-synchronization";
import fetchWrapper from "../fetchWrapper";

const loadTranslations = async (language = "en", groups = ["shared"]) => {

  const strings = getStringsFromLocalStorage(language);
  const groupsToLoad = [];
  groups.forEach(f => {
    if (!strings[f]) {
      groupsToLoad.push(f);
    }
  });
  if (groupsToLoad.length > 0) {
    const query = new URLSearchParams({ language });
    groupsToLoad.forEach((group) => query.append("groups", group));
    const url = `api/translations?${query.toString()}`;
    const loaded = await fetchWrapper({url:url});

    const result = {...strings,...loaded};
    return syncStringsToLocalStorage(language,result);


  } else {
    return strings;
  }
};

export default loadTranslations;
